import styled from 'styled-components';
import { devices } from '../../../styles/viewports';

export const UpsellBorderBox = styled.div`
  border: solid 4px;
  border-color: ${({ theme }) => theme.colors.primary};
  padding: 80px;

  @media ${devices.mobile} {
    & {
      border-left: none;
      border-right: none;
      padding-top: 2.5em;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 2.5em;
    }
  }

  @media ${devices.tablet} {
    & {
      padding: 25px;
      padding-top: 2.5em;
    }
  }
`;

export const TitleContainer = styled.div`
  margin: 0;
  @media ${devices.mobile} {
    margin-left: 1.5em;
    margin-right: 1.5em;
  }
`;

export const TextContainer = styled.div`
  margin-bottom: 2.5em;
  div > :first-child {
    margin-top: 1.5em;
  }

  @media ${devices.tablet} {
    margin-top: 0;
    div > :first-child {
      margin-top: 0.5em;
    }
  }

  @media ${devices.mobile} {
    margin-left: 1.5em;
    margin-right: 1.5em;
    & {
      div > :first-child {
        margin-top: 1em;
      }
    }
  }
`;
